import { BrowserRouter } from "react-router-dom";
import Content from "./layout/Content";
import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import Web3Provider, { Connectors } from "web3-react";
import WalletConnectApi from "@walletconnect/web3-subprovider";
import Web3ReactManager from "./components/web3-react-manager";
import { SnackbarProvider } from "notistack";
import axios from "axios";
import { AuthContextProvider } from "./context/AuthContextProvider";
import { UserDocProvider } from "./context/UserDocProvider";
import { UseWeb3Context } from "./context/UseWeb3Context";

axios.defaults.baseURL = `${process.env.REACT_APP_API_BASE_URL}`;
const { NetworkOnlyConnector, InjectedConnector, WalletConnectConnector } =
  Connectors;
const Network = new NetworkOnlyConnector({
  providerURL: "",
});

const SUPPORTED_NETWORKS = [1, 5777, 5, 420];
const Injected = new InjectedConnector({
  supportedNetworks: SUPPORTED_NETWORKS,
});
const WalletConnect = new WalletConnectConnector({
  api: WalletConnectApi,
  bridge: "https://bridge.walletconnect.org",
  supportedNetworkURLs: SUPPORTED_NETWORKS.reduce((acc, val) => {
    return {
      ...acc,
      [val]: "",
    };
  }, {}),
  defaultNetwork: 1,
});
const connectors = { Network, Injected, WalletConnect };

const theme = createTheme({
  typography: {
    fontFamily: "Avenir",
    h4: {
      fontWeight: "bold",
    },
    h6: {
      fontSize: "1rem",
    },
  },
  palette: {
    primary: {
      main: "#070707",
      light: "#000000",
      dark: "#101010",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          fontSize: "14px",
          borderRadius: 5,
          ...(ownerState.variant === "contained" &&
            ownerState.color === "primary" && {
              backgroundColor: "#F2C500",
              color: "#140B0B",
            }),
          "&:hover": {
            ...(ownerState.variant === "contained" &&
              ownerState.color === "primary" && {
                backgroundColor: "#F2C500",
                color: "#140B0B",
              }),
          },
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "outlined" && {
            backgroundColor: "#CECECE",
          }),
        }),
      },
    },
  },
});

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <SnackbarProvider hideIconVariant={false} maxSnack={3}>
        <ThemeProvider theme={theme}>
          <Web3Provider connectors={connectors} libraryName={"ethers.js"}>
            <Web3ReactManager>
              <BrowserRouter>
                <AuthContextProvider>
                  <UserDocProvider>
                    <UseWeb3Context>
                      <Navbar />
                      <Content />
                      <Footer />
                    </UseWeb3Context>
                  </UserDocProvider>
                </AuthContextProvider>
              </BrowserRouter>
            </Web3ReactManager>
          </Web3Provider>
        </ThemeProvider>
      </SnackbarProvider>
    </StyledEngineProvider>
  );
}

export default App;
